<template>
   <div class="text-input">
      <label><b>{{label}}</b></label>
      <!-- <Datepicker :disabled="readOnly" clear-button @cleared="setDateToNull" bootstrapStyling :value="value" @input="updateValue($event)"/> -->
      <DxDateBox :disabled="readOnly" stylingMode="outlined" :show-clear-button="true" :value="displayDate" @value-changed="updateValue"/>
   </div>
</template>

<script>
import Datepicker     from 'vuejs-datepicker'

import DxDateBox from 'devextreme-vue/date-box';
import moment         from 'moment'
export default {
  components:{ DxDateBox, Datepicker },
  name: "DatePicker",
  props: ['label', 'placeholder', 'readOnly', 'value'],
  data(){
     return {
        displayDate: null,
     }
  },
  methods: {
     updateValue(e){
        if(e === undefined ) return;
        let formattedDate;
        if(e.value === null){
           formattedDate = null;
        } else {
           formattedDate = moment(e.value).format('L');
        }
        
        this.$emit('input',formattedDate);
        this.$emit('change');
     },
     setDateToNull(){
        this.$emit('input',  null );
        this.$emit('change');
     },
     setDisplayDate(){
        if(this.value === "Invalid date"){
           this.displayDate = null;
           return;
        }
        this.displayDate = this.value;
     }
  },
  watch: {
     value: function(){
        this.setDisplayDate();
     }
  },
  created(){
     this.setDisplayDate();
  }
}
</script>

<style lang="scss" scoped>

</style>
